<template>
  <section class="app-main" v-loading="fullscreenLoading" element-loading-text="实验正在加载中，请稍后！">
    <el-row :gutter="10">
        <div class="changeCss">
            <div class="notice2" v-if="isShowTs">
                <span class="svg2-containerN">
                    <svg-icon icon-class="dp2" />
                </span>
                <div class="notice2-title">
                    <span>温馨提示：您的账号使用期限为  {{ parseTime(user.createTime) }} 至 {{ parseTime(user.accountTerm) }}  账号到期后当前账号将会停用哦！<span class="countNum">（{{this.count}}s）后关闭</span></span>
                </div>
                <div class="closeNotice2"><img src="../../assets/images/newimg/close.png" alt="" @click="displayN"></div>
            </div>
            <el-col :xs="24" :sm="24" :lg="6" :xl="6">
                <div class="aside" style="margin-right:0;border:1px solid #eee;">
                    <div class="menu">
                        <h3 class="panel-title">实验分类<el-button type="primary" size="mini" style="float:right;margin-top:5px;" @click="Eliminate">清除分类</el-button></h3>
                        <!-- 知识点 -->
                        <!-- el-tree方法 -->
                        <div class="tree-el">
                        <!-- 这里是userSubject为null的时候默认展示全部 -->
                            <el-tree
                                :data="data3"
                                highlight-current
                                :props="defaultProps3"
                                node-key="id"
                                accordion
                                @node-click="handleOpen3">
                                <span class="custom-tree-node" slot-scope="{ node }">
                                    <span :title="node.label">{{ node.label }}</span>
                                </span>
                            </el-tree>
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :lg="18" :xl="18">
                <div class="contentlist" style="float:left;margin-left:0;border:1px solid #eee;width:99%;">
                    <div class="Experimentlist">
                    <el-row>
                        <el-col :xs="24" :sm="24" :lg="24" :xl="24">
                            <div class="contentl">
                                <p class="tit">
                                    实验列表
                                </p>
                                <div class="break" style="font-size:14px;margin-left:20px;margin-bottom:15px;float:left;margin-top:28px;"><span>{{eduName}}</span></div>
                                <ul>
                                    <li>
                                        <el-input placeholder="输入实验名称进行搜索" clearable v-model="search" @keyup.enter.native="searchto2" class="input-with-select" v-if="inpu2" @change="closeSearch2">
                                                <el-button slot="append" @click="searchto2" style="border-top:1px solid #DCDFE6;"><i><img src="../../assets/images/portal/magnifier.png" alt=""></i></el-button>
                                                <el-button slot="append" icon="el-icon-refresh-left" @click="Rescreening2" style="border-left:1px solid #DCDFE6;"></el-button>
                                        </el-input>
                                    </li>
                                </ul>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row style="margin:10px;" class="exChange">
                        <el-col :xs="24" :sm="24" :lg="24" :xl="24">
                            <div class="list" v-if="itemOk">
                                <div class="noshow" v-if="dataList==''">
                                    <span>该分类下暂时没有实验</span>
                                    <p><img src="../../assets/images/portal/noex.png" alt=""></p>
                                </div>
                                <el-row :gutter="20">
                                    <el-col :xs="12" :sm="8" :lg="8" :xl="8" v-for="(item,index) in dataList" :key="index" class="item">
                                    <div class="itemIn">
                                        <div class="pic" @click="infoex(item)">
                                        <el-image fit="cover" :src="imageChanges[index]" :alt="item.title" :title="item.explanatoryNote">
                                            <div slot="error" class="image-slot">
                                                <img src="../../assets/images/portal/nophoto.png">
                                            </div>
                                        </el-image>
                                        <div class="pichover" v-if="item.isDemonstration == 1"><i class="el-icon-lock"></i></div>
                                            <div class="tbtj" :class="{'box3':item.isStudy == 1}" v-if="item.isStudy !== null">
                                                <b class="left-top">{{item.isStudy | isStudy}}</b>
                                            </div>
                                            <div class="tbtj" :class="{'box4':item.isStudy == null}" v-else>
                                                <b class="left-top">{{item.isStudy | isStudy}}</b>
                                            </div>
                                            <!-- <div class="box" :class="{'box2':item.collectFees==1}">
                                                <b class="right-top">{{item.collectFees | isCollectFees}}</b>
                                            </div> -->
                                        </div>
                                        <h5 class="titl"><i :class="{'isRecomm':item.isRecomm==1}"></i>{{item.title}}</h5>
                                        <div class="pick">
                                            <!-- <p>评分：
                                                <el-rate
                                                    v-model="item.average"
                                                    disabled
                                                    disabled-void-color="#c8c8c8"
                                                    >
                                                </el-rate>
                                            </p> -->
                                            <p><i class="el-icon-view" style="margin-right:9px;"></i>浏览量：
                                                <span class="browseNum">{{item.browseNum}}</span>
                                            </p>
                                        </div>
                                    </div>
                                    </el-col>
                                </el-row>
                                <div class="paginations" v-if="pagin2">
                                    <el-pagination
                                        background
                                        hide-on-single-page
                                        layout="prev, pager, next"
                                        :total="pageData.total"
                                        @current-change="pageChange2"
                                        :current-page.sync="page"
                                        :page-size='12'
                                        >
                                    </el-pagination>
                                </div>
                            </div>
                        </el-col>
                    </el-row>
                    </div>
                </div>
            </el-col>
        </div>
      <div id="el-main-footer" v-if="isShowFooter">
        <span>{{this.footer.footerName}}</span>
        <span v-if="this.footer.tenantRecord"> ⋅ </span>
        <span>{{this.footer.tenantRecord}}</span>
      </div>
        <div id="unitybox" v-if="videoEx">
            <div id="bo">
                <div id="buttombox">
                        <p id="closeunV" @click="closeV" style="cursor: pointer;float:left"><i><img src="../../assets/images/portal/close.png" alt=""></i></p>
                </div>
                <div class='demo'>
                    <video :id="'m3u8'+this.modalvideo.id" class="video-js" preload="auto" v-if="vshow">
                        <source :src="this.modalvideo.videom3u8path" type="application/x-mpegURL">
                    </video>
                </div>
            </div>
        </div>
    </el-row>
  </section>
</template>

<script>
import request from '@/utils/request'
import $ from 'jquery'
import { parseTime } from '@/utils/index'

import videojs from 'video.js';
import 'videojs-contrib-hls';
import 'videojs-markers';

export default {
    name: 'AppMain',
    inject:['reload'],
    data(){
        return{
            vshow:false,
            modalvideo:{
                videom3u8path:'',
                id:'',
                videopic:'',
                markersView:[]
            },
            videoEx:false,
            isShowFooter:false,
            itemOk:false,
            resourseId:[],
            imageChanges:[],
            tenantId:0,
            // 侧边栏
            getType:0,
            user:{},
            userId:'',
            getSubject:0,
            rescr:false,
            rescr2:false,
            getinfos:0,
            inpu2:true,
            data3:[{}],
            defaultProps3: {
                children: 'children',
                label: 'chapterName'
            },
            fullscreenLoading: false,
            firstMenu:[],
            secMenu:[],
            eduId:'',
            edutreeid:'',
            information:[],
            //   主要内容
            eduId:0,
            // url:'https://i.loli.net/2019/07/31/5d40fc0c0704d86318.png',
            errorUserPhoto:'https://i.loli.net/2019/07/31/5d40ffb611a2f82333.png',
            page:0,
            pagin2:true,
            isfree:'',
            search: '',
            themeType:'',
            materialType:'',
            infoNumber:0,
            // type:'',
            dataList:[{}],
            eduId:'',
            eduName:'',
            pageData:{
                currentPage:1,
                pagesize:12,
                pagenumber:0,
                total:0,
                average:0,
            },
            isShowTs:false,
            count:'',
            resource:'',
        }
    },
　　filters: {
        isCollectFees: function (value) {
            if(value==0){
                return '免费'
            }else if(value==1){
                return '收费'
            }
        },
        isStudy: function (value) {
            if(value==0){
                return '同步'
            }else if(value==1){
                return '探究'
            }else{
                return '视频'
            }
        },
        isRecomm: function (value) {
            if(value==0){
                return '推荐'
            }else if(value==1){
                return '不推荐'
            }
        },
　　},
    components:{
    },
    computed: {},
    created(){
        this.getinfo();
        this.fullscreenLoading = true;
        if(sessionStorage.getItem('isShowTs') == 1){
            this.isShowTs = false;
        }else{
            setTimeout(() => {
                this.displayN();
            }, 10000);
        }
    },
    methods: {
        parseTime,
        timeOut(){
            const TIME_COUNT = 10;
            if(!this.timer){
                this.count = TIME_COUNT;
                this.show = false;
                this.timer = setInterval(()=>{
                if(this.count > 0 && this.count <= TIME_COUNT){
                    this.count--;
                }else{
                    this.show = true;
                    clearInterval(this.timer);
                    this.timer = null;
                }
                },1000)
            }
        },
        displayN(){
            this.isShowTs = false;
            sessionStorage.setItem('isShowTs',1);
        },
        // 初始化视频
        Initialization(){
            this.$nextTick(() => {
                this.videoPlayer = videojs('m3u8'+this.modalvideo.id, {
                //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
                controls: true,
                //自动播放属性,muted:静音播放
                autoplay: "false",
                //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
                preload: "auto",
                poster: this.modalvideo.videopic
                })
                this.videoPlayer.markers({
                    markerStyle: {
                        'width': '8px',
                        'background-color': '#2174ff'
                    },
                    markers: this.modalvideo.markersView,
                    markerTip: {
                        display: true,
                        text: function (marker) {
                        return  marker.text;
                        }
                    },
                    onMarkerReached: function (marker) {
                    }
                });
                videojs('m3u8'+this.modalvideo.id).pause();
            });
        },
        // 获取实验视频信息
        getExVideo(){
            request({
                method:'get',
                url:'api/searchJdVideosById?id='+this.infoIds
            }).then(res=>{
                this.modalvideo.videom3u8path = res.data.video.videom3upath
                this.modalvideo.id = res.data.video.id
                this.modalvideo.videopic = res.data.video.videopic
                this.templist = []
                res.data.point.forEach(item=>{
                    const itList = {time: item.pointtime, text: item.pointname,info:item.pointinfo};
                    this.templist.push(itList);
                });
                this.modalvideo.markersView = this.templist;
                this.videoEx = true;
                this.vshow = true;
                this.Initialization();
            })
        },
        // 关闭视频
        closeV(){
            this.videoEx = false;
            this.vshow = false;
            this.videoPlayer.dispose();
        },
        // 清空搜索框-章节
        closeSearch2(val){
            if(val == ''){
                this.searchto2();
            }
        },
        // changeTitle(){
        //   let title = this.$route.meta.title
        //   console.log(this.footer.tenantName))
        //   if(title !== this.footer.tenantName){
        //     this.$route.meta.title = this.footer.tenantName
        //   }else{
        //     this.$route.meta.title = '3D虚拟仿真实验室'
        //   }
        // },
        // 清除分类
        Eliminate(){
            this.$confirm('此操作将会清除分类条件, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            cancelButtonClass: 'messageBox-btnF',
            confirmButtonClass: 'messageBox-btnTent',
            }).then(() => {
                this.eduId = ''
                this.eduName = ''
                this.getTrees3();
                this.getList2();
            }).catch(() => {
            });
        },
        // 按章节
        Rescreening2(){
            this.$confirm('此操作将会清除输入框内容, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            cancelButtonClass: 'messageBox-btnF',
            confirmButtonClass: 'messageBox-btnTent',
            }).then(() => {
                this.search = '';
                let page = {}
                page.pagesize = 12;
                page.pagenumber = 0;
                page.currentPage = 1;
                page.total = 0;
                page.search = '';
                this.pageData =page
                this.getList2()
            }).catch(() => {      
            });
        },
        //按章节
        searchto2(){
            var specialKey = "[`@~!#$^&*()=|%{}':;',[].<>/~！#￥……&*（）——|{}【】‘；：”“'。，、？]‘'";
            for(var i = 0;i<specialKey.length;i++){
                if(this.search == specialKey[i]){
                    this.$message({
                        message:"此为非法字符，请确认后输入",
                        type:'error'
                    })
                    return
                }
            }
            this.pageData.pagenumber = 0;
            this.getList2();
        },
        infoex(item){
          if(item.region == 1){
              this.infoIds = item.id
              if(this.infoIds != undefined || this.infoIds != null || this.infoIds != ''){
                request({
                    url:'api/videoBrowseNum?resourceid='+item.id,
                    method:'put'
                }).then(res=>{
                    this.getList2();
                })
                this.getExVideo();
              }else{
                this.$message({
                    message:'实验获取失败，请联系管理员或重试',
                    type:'error'
                })
              }
          }else{
            if(item.isDemonstration == 1){
                return;
            }else{
                if(item.collectFees == 1){
                    this.$message({
                        message:'对不起，您还没有购买过此实验，请先购买，或联系销售人员',
                        type:'error'
                    })
                }else{
                    if(item.isStudy == 0){
                        // console.log("欢迎进入同步实验")
                        this.$router.push({
                        path: "/Cinfo",
                        query: {
                            infoId:item.id,
                            // infoTitle:item.title,
                            // infoPhoto:item.fileThumbnail,
                            infoBrowseNum:item.browseNum,
                            // infoAerage:item.average,
                            // infoScoringMan:item.scoringMan,
                            // infoTotalPoints:item.totalPoints,
                            infoNumber:this.infoNumber,
                            infoTreeId:this.eduId,
                            infoNodeName:this.eduName,
                            infoIsFree:this.isfree,
                            infoSearch:this.search,
                            infoStudy:item.isStudy,
                            infoisStudy:this.isStudy
                            }
                        });
                    }else if(item.isStudy == 1){
                        // console.log("欢迎进入探究实验")
                        this.$router.push({
                        path: "/CinfoTj",
                        query: {
                            infoId:item.id,
                            // infoTitle:item.title,
                            // infoPhoto:item.fileThumbnail,
                            infoBrowseNum:item.browseNum,
                            // infoAerage:item.average,
                            // infoScoringMan:item.scoringMan,
                            // infoTotalPoints:item.totalPoints,
                            infoNumber:this.infoNumber,
                            infoTreeId:this.eduId,
                            infoMb:this.userVIP,
                            infoNodeName:this.eduName,
                            infoIsFree:this.isfree,
                            infoSearch:this.search,
                            infoStudy:item.isStudy,
                            infoisStudy:this.isStudy
                            }
                        });
                    }
                    // window.open(routeUrl .href, '_blank');
                }
            }
          }
        },
        //通过章节获取
        getList2(type){
            this.fullscreenLoading = true;
            this.pagin = false
            this.pagin2 = true
            request({
                 method:'get',
                 url: 'api/hsTenant?'+'eduTreeIds='+this.eduId+'&userId='+this.userId+'&page='+this.pageData.pagenumber+'&size='+this.pageData.pagesize+'&themeType='+this.themeType+'&materialType='+this.materialType+'&collectFees='+this.isfree+'&title='+this.search+'&shelves=1'+'&noderes=1'+'&sort=stick%2Cdesc'+'&userCollect=0'+'&tenantId='+this.tenantId+'&sort=tenantSequence%2Cdesc'
            }).then(res=>{
                this.dataList = res.data.content;
                let changeimg = res.data.content;
                this.imageChanges = [];
                for(let i in changeimg){
                    if(changeimg[i].fileThumbnail == null){
                        this.imageChanges.push(changeimg[i].fileThumbnail)
                    }else{
                        this.imageChanges.push((changeimg[i].fileThumbnail.split("").reverse().join("").substring(4)).split("").reverse().join("")+'_480x270.png')
                    }
                }
                this.fullscreenLoading = false;
                var temp = {}
                temp.pagesize=this.pageData.pagesize;
                temp.pagenumber=this.pageData.pagenumber;
                temp.total =Number(res.data.totalElements);
                this.pageData=temp
                this.itemOk = true
            }).catch(err=>{
                this.$confirm('当前帐户已登录到另一个设备上，或不在使用时间内', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    cancelButtonClass: 'messageBox-btnF',
                    confirmButtonClass: 'messageBox-btnTent',
                    type: 'warning',
                }).then(() => {
                    this.LogOutT();
                }).catch(() => {
                    this.LogOutT();
                })
            })
        },
        LogOutT() {
            if(this.tenantId == 13){
                this.$store.dispatch('LogOutT').then(() => {
                this.reload() // 为了重新实例化vue-router对象 避免bug
                this.$router.push({path:'/party'});
                })
            }else if(this.tenantId == 25 || this.tenantId == 19){
                this.$store.dispatch('LogOutT').then(() => {
                this.reload() // 为了重新实例化vue-router对象 避免bug
                this.$router.push({path:'/partyM'});
                })
            }else if(this.tenantId == 34){
                this.$store.dispatch('LogOutT').then(() => {
                this.reload() // 为了重新实例化vue-router对象 避免bug
                this.$router.push({path:'/partyHN'});
                })
            }else if(this.resource !== null){
                this.$store.dispatch('LogOutT').then(() => {
                this.reload() // 为了重新实例化vue-router对象 避免bug
                this.$router.push({path:'/partyM'});
                })
            }else{
                this.$store.dispatch('LogOutT').then(() => {
                    this.reload() // 为了重新实例化vue-router对象 避免bug
                    this.$router.push({path:'/infoTenant?tenantNum='+this.tenantId});
                })
            }
        },
        pageChange2(data){
            // 滚动到顶部
            let currentPosition,timer;
            let speed=30;
            setTimeout(() => {
                timer=setInterval(function(){
                    currentPosition=document.documentElement.scrollTop || document.body.scrollTop;
                    currentPosition-=speed;
                    if(currentPosition>0){
                        window.scrollTo(0,currentPosition);
                    }else{
                        window.scrollTo(0,0);
                        clearInterval(timer);
                    }
                },1);
            }, 100)
            this.pageData.pagenumber = data-1;
            this.getList2()
        },
      //获取info
      getinfo(){
        request({
          method:'get',
          url:'auth/info'
        }).then(res=>{
            var changecolor = res.tenant.projectColor
            this.tenantId = res.tenant.id
            if(this.tenantId !== '' && res.tenant !== 0){
                this.getTenant();
            }else{
                this.$message({
                    message:'当前账号异常，请重新登录！',
                    type:'error'
                })
                this.fullscreenLoading = false;
            }
            this.user = res.jwtUser
            this.userId = res.jwtUser.id
            this.footer = res.tenant
            this.resource = res.resource
            if(res.resource !== null){
                if(localStorage.getItem('newKey') !== 'undefined'){
                    sessionStorage.setItem('userBackIndex', 0)
                }else{
                    sessionStorage.setItem('userBackIndex', 1)
                }
            }
            if(this.footer.tenantFooter == 0){
                this.isShowFooter = false;
            }else{
                this.isShowFooter = true;
            }
            if(sessionStorage.getItem('isShowTs') == 1){
                this.isShowTs = false;
                if(this.footer.tenantNav == 1){
                    $(".changeCss").css("margin-top","70px");
                }else{
                    $(".changeCss").css("margin-top","0");
                }
            }else{
                this.isShowTs = true;
                this.timeOut();
                if(this.footer.tenantNav == 1){
                    $(".changeCss").css("margin-top","70px");
                }else{
                    $(".changeCss").css("margin-top","0");
                }
            }
        })
      },
      getTenant(){
        request({
            method:'get',
            url:'api/tenant/'+this.tenantId
        }).then(res=>{
            this.chapterTree = res.chapterTree
            this.getTrees3()
            this.getList2()
        })
      },
      // tenant
      getTrees3(){
        if(this.tenantId == 4 || this.tenantId == 5){
            request({
                method:'get',
                url:'api/tenantChapter?tenantId='+this.tenantId
            }).then(res=>{
                this.data3 = res.data
            })
        }else{
            request({
                method:'get',
                url:'api/tenant/getChapterTrees?tenantId='+this.tenantId
            }).then(res=>{
                this.data3 = res.data
            })
        }
      },
      // change(index){
      //   this.bus.$emit("ification",item)
      //   this.eduId = index
      // },
      // 实验分类点击事件
      handleOpen3(data,index) {
        this.eduId = data.id
        this.eduName = data.nodenamez
        this.pageData.pagenumber = 0;
        this.page = 1;
        this.getList2()
      },
      // 实验分类关闭事件
      handleClose(key, keyPath) {
      },
      handleClose2(key, keyPath) {
      }
    }
}
</script>

<style scoped>
    @import '../../../node_modules/videojs-markers/dist/videojs.markers.min.css';
    @import '../../views/layout/components/tenantEx.css';
    .changeCss{
        margin-top: 70px;
    }
    /* 用户提示信息 */
    .notice2{
        margin: 0 auto;
        width: 98%;
        height: 30px;
        background-color: #f5faff;
        border: 1px solid #005faf;
        border-radius: 4px;
        margin-top: 10px;
    }
    .svg2-containerN {
        float: left;
        padding: 5px;
        vertical-align: middle;
        width: 30px;
        display: inline-block;
    }
    .notice2-title{
        float: left;
        height:28px;
        line-height: 28px;
        color: #005faf;
        font-size: 14px;
        white-space:nowrap; text-overflow:ellipsis; -o-text-overflow:ellipsis; overflow:hidden;
    }
    .closeNotice2{
        float: right;
        width: 12px;
        height: 12px;
        margin-top: 5px;
        margin-right: 8px;
    }
    .closeNotice2 img{
        width: 100%;
        height: 100%;
        cursor: pointer;
    }
    .countNum{
        text-align: center;
        font-size: 14px;
        color: #005faf;
        width: 20px;
        height: 20px;
        line-height: 20px;
    }
    .demo>>>.m3u8Video102-dimensions{
        width: 100%;
        height: 100%;
    }
    .demo>>>.video-js{
        width: 100%;
        height: 100%;
    }
    .demo>>>.vjs-marker{
        position: absolute;
        left: 0;
        bottom: 0em;
        opacity: 1;
        height: 100%;
        transition: opacity .2s ease;
        -webkit-transition: opacity .2s ease;
        -moz-transition: opacity .2s ease;
        z-index: 100;
    }
    .demo>>>.vjs-marker:hover{
        cursor: pointer;
        -webkit-transform: scale(1.3, 1.3);
        -moz-transform: scale(1.3, 1.3);
        -o-transform: scale(1.3, 1.3);
        -ms-transform: scale(1.3, 1.3);
        transform: scale(1.3, 1.3);
    }
    .demo>>>.vjs-tip{
        display: block;
        opacity: .8;
        padding: 5px;
        font-size: 12px;
        position: absolute;
        bottom: 14px;
        z-index: 1000000;
    }
    .demo>>>.vjs-tip .vjs-tip-inner{
        -webkit-border-radius:4px;
        padding:  5px 8px 5px 8px;
        background-color: #000;
        text-align: center;
        max-width: 200px;
        color: #fff;
        line-height: 14px;
    }
    .demo>>>.vjs-big-play-button{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .demo>>>.video-js .vjs-picture-in-picture-control{
        display: none;
    }
    /* 同步 探究 */
    .tbtj{
        width: 14%;
        height: 30px;
        line-height: 30px;
        background-color: #00d4fa;
        border-radius: 2px;
        position: absolute;
        left: 3%;
        top: 5%;
        color: #fff;
        font-size: 18px;
    }
    .left-top{
        font-weight: 400;
    }
    .box3{
        background-color: #ffc001;
    }
    .box4{
        background-color:#005faf;
    }
    .app-main /deep/ .el-loading-mask{
        width:100%;
        height:100vh;
    }
    #el-main-footer{
        background:none repeat scroll 0 0 white;
        border-top:1px solid #e7eaec;
        overflow:hidden;
        padding:10px 6px 0px 6px;
        font-size:0.7rem !important;
        color:#e6e6e6;
        letter-spacing:0.8px;
        font-family:Arial, sans-serif !important;
        position: fixed;
        bottom: 0;
        height: 33px;
        z-index:1000;
        width: 100%;
    }
    .app-main {
        /*84 = navbar + tags-view = 50 +34 */
        min-height: calc(100vh - 84px);
        width: 100%;
        position: relative;
        overflow: hidden;
        /* margin-left:64px !important; */
    }
    .aside, .contentlist{
      margin: 10px 10px 30px 10px;
      background-color: #fff;
    }
    .aside{
        height: calc(100vh - 100px);
    }
  /* 侧边栏 */
    .menu{
        width: 100%;
        margin-bottom: 30px;
    }
    .panel-title{
      margin-top: 0;
      font-weight: 400;
      color: #333;
      width:90%;
      font-size: 20px;
      line-height: 39px;
      margin: 0 0 31px 15px;
      padding-top: 17px;
      border-bottom: 1px solid #f0f0f0;
    }
    .el-menu-panel{
        width: 90%;
        margin: 15px;
        border-right: none;
    }
    .el-submenu{
        background: #005faf;
    }
    .el-submenu__title>span{
        color: #fff;
        font-size: 14px;
        font-weight: 600;
    }
    .el-menu-tw{
        background: #fff;
        text-indent: 30px;
        border-bottom: 1px solid #eee;
        border-left: 2px solid #005faf;
        border-right: 2px solid #005faf;
        margin-top: 0;
        border-radius: 0;
    }
    .el-menu-tw:last-of-type{
        border-bottom: 2px solid #005faf;
        border-radius: 0;
    }
    .el-menu-tw2{
        background: #fff;
        text-indent: 5px;
        border-bottom: 1px solid #eee;
        border-left: 2px solid #005faf;
        border-right: 2px solid #005faf;
        margin-top: 0;
        border-radius: 0;
    }
    .el-menu-tw2:last-of-type{
        border-bottom: 2px solid #005faf;
        border-radius: 0;
    }
    .el-menu-tw3{
        background: #fff;
        text-indent: -5px;
        margin-top: 0;
        border-radius: 0;
    }
    .el-menu-tw3:last-of-type{
        border-radius: 0;
    }
    .el-menu-th{
        background: #fff;
        border-bottom: 1px solid #eee;
        border-left: 1px solid #005faf;
        border-right: 1px solid #005faf;
        margin-top: 0;
        border-radius: 0;
    }
    .el-menu-th:last-of-type{
        border-bottom: none;
    }
    .el-menu-th:first-of-type{
        border-top: 1px solid #eee;
    }
    .el-menu-th2{
        background: #fff;
        border-bottom: 1px solid #eee;
        border-left: 1px solid #005faf;
        border-right: 1px solid #005faf;
        margin-top: 0;
        border-radius: 0;
        text-indent: -15px;
    }
    .el-menu-th2:last-of-type{
        border-bottom: none;
    }
    .el-menu-th2:first-of-type{
        border-top: 1px solid #eee;
    }
    .is-active{
        color: #005faf;
    }
    .el-switch{
        float: right;
        margin: 15px 0;
    }
    .tree-el{
        overflow-x: auto;
    }
    .el-tree{
        min-width: 100%;
        display: inline-block;
    }
    /* 主要内容 */
    .Experimentlist{
        width: 100%;height: 100%;background: #fff;
        float:left;
    }
    .tit{
        margin: 0;
        margin-top: 25px;
        font-size: 20px;
        font-weight: 400;
        float: left;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        padding: 0 126px;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    .list{
        width: 100%;
        height: 100%;
    }
    .item{
      float: left;
      margin-bottom: 20px;
      z-index: 10;
    }
    .itemIn{
        width:100%;
        float: left;
        position: relative;
    }
    .itemIn:hover{
        transition: all 0.2s linear 0s;
        transform: scale(1.01);
        box-shadow: 2px 2px 10px #888;
    }
    .itemIn:hover .collection{
        display: block;
    }
    .pic{
        width: 100%;
        text-align: center;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        height:calc( (23.1vw / 16) * 9);
    }
    .pic /deep/ .el-image{
        width:100%;
        height: 100%;
        float:left;
    }
    .pic img{
        width:100%;
        height: 100%;
    }
    /* 收费 免费 */
    .box{
        width: 0;
        height: 0;
        border-top: 60px solid  #46b8da;
        border-left: 60px solid transparent;
        margin-bottom: -100px;
        position: absolute;
        right: 0;
        top: 0;
        float: right !important;
        box-sizing: border-box;
        z-index: 200;
    }
    .box2{
        border-top: 60px solid  #005faf;
    }
    .right-top{
        width: 60px;
        font-weight: 600;
        color: #fff;
        position: relative;
        right: 50px;
        top: -50px;
        display: block;
        box-sizing: border-box;
        /* transform: rotate(80deg); */
        -webkit-transform:rotate(45deg)
    }
    .pic:hover .pichover{
        display: block;
        align-items:center;
        display: -webkit-flex;
        justify-content:center;
        cursor: pointer;
    }
    .pichover{
        width: 100%;
        height: 100%;
        font-size: 22px;
        font-weight: 600;
        position: absolute;
        top: 0;
        left: 0;
        background: rgba(0 , 0 , 0 , 0.7);
        transform: all 0.7s;
    }
    .pichover i{
      position: absolute;
      left:50%;
      top:50%;
      transform:translate(-50%, -50%);
      font-size:30px;
      font-weight:bold;
      color:#fff;
      background-color:#005faf;
      padding:16px;
      border:3px solid #005faf;
      border-radius:50%;
    }
    .titl{
        padding-top: 17px;
        padding-left: 2%;
        font-size: 18px;
        color: #333;
        font-weight: 400;
        width: 94%;
        margin: 0;
        white-space:nowrap; text-overflow:ellipsis; -o-text-overflow:ellipsis; overflow:hidden;
    }
    .pick p{
        float: left;
        padding:5% 2% 6%;
        margin: 0;
        font-size: 16px;
        color:#999;
    }
    .el-rate{
        float: right;
        color:rgb(236, 111, 40)
    }
    .paginations{
        width: 100%;
        float: left;
        padding: 18px 20px;
    }
    .el-pagination{
        text-align: center;
        font-weight: 400;
    }
    /* 分页 */
    .paginations /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background:#005faf;
        color: #fff;
    }
     /* 搜索框 */
    .contentl /deep/ .input-with-select>.el-input__inner{
        background: #f6f6f6;
        color: #a0a0a0;
        font-size: 16px;
    }
    .contentl /deep/ .el-input-group__append button.el-button{
        background-color: #fff;
    }
    /* main */
    .contentl /deep/ .el-button+.el-button{
        margin-left: 20px;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 166px;
    }
    .noshow>span{
        font-size: 32px;
        color: #999;
    }
    .noshow>p{
        margin-top: 69px;
        margin-bottom: 158px;
        width: 593px;
        height: 349px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    .isRecomm{
        width: 18px;
        height: 20px;
        float: left;
        margin-right: 9px;
        background-image: url(../../assets/images/portal/hot.png);
        background-size: 100%;
    }
    .image-slot{
        width: 100%;
        height: 100%;
        float: left;
    }
    /* 树形下拉框 */
    .tree-el /deep/ .el-tree-node__content{
      height: 42px;
      width: 100%;
      background: #005faf;
      margin-top: 7px;
      color: #fff;
    }
    .tree-el /deep/ .el-tree-node__content:hover{
      background: #005faf;
    }
    .tree-el /deep/ .el-tree-node:focus>.el-tree-node__content{
      background: #005faf;
    }
    .tree-el /deep/ .el-tree-node__expand-icon{
      font-size: 10px;
      color: #e3e3e3;
      /* color: #005faf; */
    }
    .tree-el /deep/ .el-tree-node__content>.el-tree-node__expand-icon{
      margin-left:24px;
    }
    .tree-el /deep/ .el-tree-node__label{
      font-size: 16px;
    }
    .tree-el /deep/ .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
      background: #409EFF;
    }
    /* .el-tree-node__children>.el-tree-node>.el-tree-node__content>.el-tree-node__expand-icon{
      color: #d2d2d2;
    } */
    .tree-el /deep/ .el-tree--highlight-current>.is-expanded>.el-tree-node__children>.is-current>.el-tree-node__content{
      background: #b9d6ee;
      border-right:4px solid #005faf;
      color: #005faf
    }
    .tree-el /deep/ .el-tree--highlight-current>.is-expanded>.el-tree-node__children>.is-expanded>.el-tree-node__children>.is-current>.el-tree-node__content{
      background: #b9d6ee;
      border-right:4px solid #005faf;
      color: #005faf
    }
    .tree-el /deep/ .el-tree--highlight-current>.is-expanded>.el-tree-node__children>.is-expanded>.el-tree-node__children>.is-expanded>.el-tree-node__children>.is-current>.el-tree-node__content{
      background: #b9d6ee;
      border-right:4px solid #005faf;
      color: #005faf
    }
    .tree-el /deep/ .el-tree--highlight-current>.is-expanded>.el-tree-node__children>.is-expanded>.el-tree-node__children>.is-expanded>.el-tree-node__children>.is-expanded>.el-tree-node__children>.is-current>.el-tree-node__content{
      background: #b9d6ee;
      border-right:4px solid #005faf;
      color: #005faf
    }
    .tree-el /deep/ .el-tree--highlight-current>.is-expanded>.el-tree-node__children>.is-expanded>.el-tree-node__children>.is-expanded>.el-tree-node__children>.is-expanded>.el-tree-node__children>.is-expanded>.el-tree-node__children>.is-current>.el-tree-node__content{
      background: #b9d6ee;
      border-right:4px solid #005faf;
      color: #005faf
    }
    .tree-el /deep/ .el-tree-node__children>.el-tree-node>.el-tree-node__content{
      background: #fff;
      /* 子集高度margin：0防止误触 */
      margin-top: 0;
      color: #333;
      font-size: 16px;
    }
    /* 最后节点不展示图标 */
    .tree-el /deep/ .el-tree-node__expand-icon.is-leaf{
      color: transparent;
    }
  @media (max-width:1024px) {
    .aside{
      margin-left: 5px !important;
    }
    .contentlist{
      margin: 0 10px 30px 10px;
      margin-left:5px !important;
    }
    .el-input-group{
        display: none;
    }
    .pic{
      height: calc( (44vw / 16) * 9 );
    }
  }
  @media screen and (min-width:1025px) and (max-width:1366px){
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    .break{
        display:none;
    }
    .contentl{
        width:97%;
        border-bottom: 1px solid #eee;
        height: 65px;
        margin-left: 10px;
        margin-bottom: 16px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 95px;
    }
    .noshow>span{
        font-size: 24px;
        color: #999;
    }
    .noshow>p{
        margin-top: 49px;
        margin-bottom: 62px;
        width: 422px;
        height: 248px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
  }
  @media screen and (min-width:1367px) and (max-width:1440px){
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    .contentl{
        width:97%;
        border-bottom: 1px solid #eee;
        height: 65px;
        margin-left: 10px;
        margin-bottom: 16px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .pick p:nth-of-type(1){
        width:56%;
        float: left;
        padding:6% 0;
        margin: 0;
        font-size: 16px;
        color:#666;
    }
    .pick p:nth-of-type(2){
        width: 44%;
        float: left;
        padding:6% 0;
        margin: 0;
        font-size: 16px;
        color:#666;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 95px;
    }
    .noshow>span{
        font-size: 24px;
        color: #999;
    }
    .noshow>p{
        margin-top: 49px;
        margin-bottom: 62px;
        width: 422px;
        height: 248px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
  }
  @media screen and (min-width:1441px) and (max-width:1600px){
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    .contentl{
        width:97%;
        border-bottom: 1px solid #eee;
        height: 65px;
        margin-left: 10px;
        margin-bottom: 16px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 117px;
    }
    .noshow>span{
        font-size: 26px;
        color: #999;
    }
    .noshow>p{
        margin-top: 55px;
        margin-bottom: 96px;
        width: 474px;
        height: 279px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
  }
  @media screen and (min-width:1601px) and (max-width:1920px){
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin-right:10%;
        margin-top:100px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
        color:#fff;font-size:50px;
    }
    .menu{
      margin-bottom: 30px;
    }
    .contentl{
        width:97%;
        border-bottom: 1px solid #eee;
        height: 65px;
        margin-left: 10px;
        margin-bottom: 16px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 166px;
    }
    .noshow>span{
        font-size: 32px;
        color: #999;
    }
    .noshow>p{
        margin-top: 69px;
        margin-bottom: 158px;
        width: 593px;
        height: 349px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
  }
  @media screen and (min-width:1921px) and (max-width:2048px){
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    .contentl{
        width:97%;
        border-bottom: 1px solid #eee;
        height: 65px;
        margin-left: 10px;
        margin-bottom: 16px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 182px;
    }
    .noshow>span{
        font-size: 34px;
        color: #999;
    }
    .noshow>p{
        margin-top: 74px;
        margin-bottom: 122px;
        width: 633px;
        height: 372px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
  }
  @media (min-width:2049px){
    .unitybox p{
        position: absolute;
        top:0;
        right:0;
        margin:30px;
        margin-top: 70px;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1000;
    }
    .paginations{
        padding: 40px 0;
    }
    .contentl{
        width:97%;
        border-bottom: 1px solid #eee;
        height: 65px;
        margin-left: 10px;
        margin-bottom: 16px;
    }
    .contentl>ul{
        height: 65px;
        line-height: 65px;
        margin: 0;
        padding: 0;
        list-style: none;
        
        float: right;
    }
    .contentl>ul>li{
        width: auto;
        float: left;
        margin: 0;
        padding: 0;
        list-style: none;
    }
    /* 提示信息 */
    .noshow{
        height: auto;
        text-align: center;
        margin-top: 248px;
    }
    .noshow>span{
        font-size: 44px;
        color: #999;
    }
    .noshow>p{
        margin-top: 92px;
        margin-bottom: 246px;
        width: 791px;
        height: 465px;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
    }
    .noshow>p>img{
        width: 100%;
        height: 100%;
    }
    #el-main-footer{
      background:none repeat scroll 0 0 white;
      border-top:1px solid #e7eaec;
      overflow:hidden;
      padding:26px 6px 0px 6px;
      font-size:0.7rem !important;
      color:#e6e6e6;
      letter-spacing:0.8px;
      font-family:Arial, sans-serif !important;
      position: fixed;
      bottom: 0;
      height: 60px;
      z-index:1000;
      width: 100%;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/myComponentsT/tenant.vue